var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('el-button',{attrs:{"type":"danger","icon":"el-icon-download"}},[_c('a',{staticClass:"download_btn",attrs:{"href":_vm.href}},[_c('span',[_vm._v("Download")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }